export const config = {
  apiUrl: 'https://api.alberguesyrefugios.com'
}
export const calendar = {
  limitDateRanges: 5,
  formatDate: 'dd-mm-yyyy',
  iconArrowTop:false,
  iconCalendar:'',
  numCalendar:2
}
export const payTime = {
  minutes: 15,
  seconds: 0
}

export const errorOptions = {
  "closeButton": true,
  "debug": false,
  "newestOnTop": false,
  "progressBar": false,
  "positionClass": "toast-top-center",
  "preventDuplicates": true,
  "onclick": null,
  "showDuration": "300",
  "hideDuration": "1000",
  "timeOut": "5000",
  "extendedTimeOut": "1000",
  "showEasing": "swing",
  "hideEasing": "linear",
  "showMethod": "fadeIn",
  "hideMethod": "fadeOut"
};
export const langChange = {
  es: 'Idioma establecido como Español',
  en: 'Language established to English',
  fr: 'Langue établie au français',
  ca: 'Idioma establert com a Català'
};



// WEBPACK FOOTER //
// ./src/_config/app.config.js